import { createStyles, getStylesRef } from "@mantine/core";

const useStyles = createStyles(() => ({
  content: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    flexDirection: "column",
    // No overflow here on purpose: `overflow-x: auto` forces overflow-y to
    // compute to `auto` as well, which turned this 100vh box into a second
    // scroll container on top of the document's own scrollbar.
    backgroundColor: "#F5F5F5",
  },
  back: {
    marginTop: 20,
    fontSize: 14,
    fontFamily: "Inter",
    fontWeight: 400,
    color: "#262626",
    height: "fit-content",
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    gap: 4,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 0,
  },
  createBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    flex: 1,
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 44,
    flex: 1,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  formBox: {
    width: "100%",
    marginBlock: "10px",
    padding: "16px 23px 18px 23px",
    borderRadius: 16,
    border: "1px solid #FFF",
    backgroundColor: "#FCFCFC",
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#344054",
      marginBottom: 8,
    },
    "& .mantine-Input-wrapper": {
      padding: "0px 12px",
      height: 48,
      borderRadius: 8,
      border: "1px solid #CBD5E1",
      background: "transparent",
      transition: "border-color 0.2s ease",

      "&:focus-within": {
        borderColor: "#344054",
        outline: "none",
      },

      "& input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#0F172A",

        "&::placeholder": {
          color: "#A3A3A3",
        },

        "&:focus": {
          outline: "none",
        },
      },
    },

    "& .mantine-Select-wrapper": {
      padding: 0,
      "& .mantine-Select-input": {
        paddingLeft: 12,
        paddingRight: 36,
        height: 48,
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#0F172A",

        "&::placeholder": {
          color: "#A3A3A3",
        },
      },
    },
  },
  btnGroup: {
    marginTop: 60,
    padding: "18px 20px 0px 20px",
    borderTop: "1px solid #E5E5E5",
    gap: 17,
    alignItems: "center",
  },
  deleteBtn: {
    borderBottom: "1px solid #E4E4E7",
    marginBottom: 35,
    paddingBottom: 8,
    "& .mantine-Button-root": {
      padding: "8px 13px",
      backgroundColor: "#F7F7F7",
      borderRadius: 8,
      cursor: "pointer",
      height: 48,
      border: "none",
      "& .mantine-Button-label": {
        fontSize: "16px",
        color: "#F04438",
        display: "flex",
        alignItems: "center",
        gap: 4,
        fontFamily: "Inter",
        fontWeight: 600,
      },
    },
  },

  countBox: {
    padding: "0px 12px",
    height: 48,
    borderRadius: 8,
    border: "1px solid #CBD5E1",
    background: "transparent",
    fontSize: 14,
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#0F172A",
    display: "flex",
    alignItems: "center",
  },
   password: {
    color: "#344054", // fallback for var(--Gray-700)
    fontFamily: "Inter",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textUnderlinePosition: "from-font",
  },

  crumbBack: {
    marginTop: 24,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "7px 14px",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#F4F4F5",
    color: "#262626",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    "&:hover": { background: "#E5E5E5" },
  },
  profHead: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    padding: "20px 22px",
  },
  profAv: {
    width: 56,
    height: 56,
    borderRadius: 14,
    background: "#F3F0FB",
    color: "#43307E",
    display: "grid",
    placeItems: "center",
    fontSize: 18,
    fontWeight: 800,
    flexShrink: 0,
    fontFamily: "Inter",
  },
  profInfo: { flex: 1, minWidth: 0 },
  profNameRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  profName: {
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: "-0.015em",
    fontFamily: "Inter",
    color: "#171717",
  },
  profMeta: {
    display: "flex",
    flexWrap: "wrap",
    gap: "7px 16px",
    marginTop: 9,
    fontSize: 13,
    color: "#667085",
    fontFamily: "Inter",
    "& > span": { display: "inline-flex", alignItems: "center", gap: 6 },
  },
  profActions: { flexShrink: 0 },
  kebabSquare: {
    width: 40,
    height: 40,
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    background: "#fff",
    color: "#262626",
    "&:hover": { background: "#FAFAFA" },
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    textTransform: "uppercase",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".05em",
    padding: "4px 12px",
    borderRadius: 999,
    border: "1px solid",
    fontFamily: "Inter",
  },
  pillOgiso: { background: "#EFF6FF", color: "#1D4ED8", borderColor: "#BFDBFE" },
  pillExternal: { background: "#F3F0FB", color: "#43307E", borderColor: "#DDD6FE" },

  detailTabs: {
    marginTop: 20,
    "& .mantine-Tabs-tabsList": {
      borderBottom: "1px solid #E5E5E5",
      gap: 4,
    },
    "& .mantine-Tabs-tab": {
      padding: "11px 15px",
      fontSize: 13.5,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#667085",
    },
    "& .mantine-Tabs-tab[data-active]": {
      color: "#53389E",
      borderColor: "#53389E",
    },
    // Picks up the active tab's purple, so the badge tracks the tab it sits in.
    [`& .mantine-Tabs-tab[data-active] .${getStylesRef("tabCount")}`]: {
      color: "#53389E",
      background: "#F3F0FB",
    },
  },
  tabCount: {
    ref: getStylesRef("tabCount"),
    fontSize: 11,
    fontWeight: 700,
    color: "#667085",
    background: "#F4F4F5",
    borderRadius: 999,
    padding: "1px 7px",
    fontFamily: "Inter",
  },
  tabsPanel: {
    marginTop: 20,
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    padding: "24px 22px 26px",
  },
  provForm: {
    maxWidth: 730,
    margin: "0 auto",
  },
  provInputWrap: {
    "& label": {
      fontSize: 13,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#344054",
      marginBottom: 6,
      textTransform: "none",
      letterSpacing: 0,
    },
    "& .mantine-Input-wrapper": {
      padding: "0px 12px",
      height: 38,
      borderRadius: 8,
      border: "1px solid #E5E5E5",
      background: "transparent",
      transition: "border-color 0.2s ease",
      "&:focus-within": { borderColor: "#53389E", outline: "none" },
      "& input": {
        height: "100%",
        border: "none",
        padding: 0,
        background: "transparent",
        minHeight: "unset",
        fontSize: 13.5,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",
        "&::placeholder": { color: "#9CA3AF" },
        "&:focus": { outline: "none" },
        "&:read-only": { color: "#667085", cursor: "default" },
      },
    },
    "& .mantine-Select-wrapper": {
      padding: 0,
      height: 38,
      "& .mantine-Select-input": {
        height: 38,
        minHeight: 38,
        paddingLeft: 12,
        paddingRight: 36,
        fontSize: 13.5,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",
        border: "1px solid #E5E5E5",
        "&::placeholder": { color: "#9CA3AF" },
      },
    },
  },
  // Companion to provInputWrap for Textarea: that class pins the wrapper to a
  // single-line 38px box and only styles `input`, so a textarea kept its own
  // border and spilled out of the wrapper. Let the wrapper grow instead and
  // move the padding/typography onto the textarea itself.
  provTextareaWrap: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      minHeight: 38,
      padding: 0,
      "& textarea": {
        border: "none",
        borderRadius: 8,
        background: "transparent",
        padding: "9px 12px",
        minHeight: 36,
        fontSize: 13.5,
        fontWeight: 400,
        fontFamily: "Inter",
        lineHeight: 1.5,
        color: "#171717",
        "&::placeholder": { color: "#9CA3AF" },
        "&:focus": { outline: "none" },
        "&:read-only": { color: "#667085", cursor: "default" },
      },
    },
  },
}));

export default useStyles;
